import React from "react";
import { useNavigate } from "react-router-dom";

function Terms_Conditions() {
  const navigate = useNavigate();

  return (
    <section className="privacy-section">
      <div className="privacy-hero">
        <div className="overlay">
          <h1>Terms & Conditions</h1>
        </div>
      </div>

      <div className="privacy">
        <div className="container">
          {/* <div className="head_title">
            <h4>GDPR & PRIVACY POLICY</h4>
          </div> */}
          <p className="head-text">
            Adesh Tours and Travels <br></br>(MSME: Udyam-GJ-01-0593691 —
            Registered in India)
          </p>
          <div className="policy-block">
            <h4>1. Introduction</h4>
            <p className="text">
              These Terms & Conditions (“Terms”) govern all travel bookings,
              tour packages, services, reservations and transactions made with 
              <strong>  Adesh Tours and Travels</strong> (“Company”, “we”, “us”,
              “our”). By making a booking with us or using our services, you
              (“Client”, “you”, “your”) agree to be bound by these Terms &
              Conditions. All bookings are subject to availability, acceptance
              of these Terms, and written confirmation issued by the Company.
            </p>

            {/* <p>
              <span>Log Files:</span> As is true of most websites, we gather
              certain information automatically and store it in log files. This
              information includes IP addresses, browser type, Internet service
              provider (ISP), referring/exit pages, operating system, date/time
              stamp, and clickstream data. We use this information to maintain
              and improve the performance of the Services.
            </p>

            <p className="text"> 
              <span> Analytics:</span> We use analytics services (including, but
              not limited to, Google Analytics) to help analyze how users use
              the Site. Analytics services use Cookies to collect information
              such as how often users visit the Site and we use the information
              to improve our Site and Services. The analytics services' ability
              to use and share information collected by them is restricted by
              their terms of use and privacy policy, which you should refer to
              for more information about how these entities use this
              information.
            </p>

            <p className="text"> 
              <span> Location Information:</span> If you have enabled location
              services on your mobile device, we may collect your location
              information to improve the Services we offer. If you do not want
              this information collected, you can disable location services on
              your device.
            </p>

            <p className="text"> 
              <span> Cookies:</span> “Cookies” are small pieces of information
              (text files) that a website sends to your computer’s hard drive
              while you are viewing the website. These text files can be used by
              websites to make the users experience more efficient. The law
              states that we can store these cookies on your device if they are
              strictly necessary for the operation of this site. For all other
              types of cookies we need your permission. To that end, this site
              uses different types of cookies. Some cookies are placed by third
              party services that appear on our pages. We and some third parties
              may use both session Cookies (which expire once you close your web
              browser) and persistent Cookies (which stay on your computer until
              you delete them) to provide you with a more personal and
              interactive experience on our Services and to market the Services
              or other products. Marketing cookies are used to track visitors
              across websites. The intention is to display ads that are relevant
              and engaging for the individual user and thereby more valuable for
              publishers and third party advertisers. This tracking is done on
              an anonymous basis and, while not an exhaustive list, some of the
              companies we work with are Google, AppNexus, Criteo, Rubicon,
              Pubmatic and DistrictM. To learn more about this practice,
              including the Self Regulatory Principles for Online Advertising,
              to which we adhere, you can visit www.aboutads.info/choices,
              optout.networkadvertising.org and www.youronlinechoices.com
            </p> */}
          </div>
          <div className="policy-block">
            <h4>2. Definitions</h4>
            <p className="text">
              <strong>Booking</strong>

              <p className="text">
                Reservation of travel services including but not limited to
                flights, hotels, tours, cruises, transfers, activities, and
                other related travel products.
              </p>
            </p>
            <p className="text">
              <strong>Services</strong>
              <p className="text">
                Travel arrangements provided by us or arranged through
                third-party suppliers on your behalf.
              </p>{" "}
            </p>
            <p className="text">
              <strong>Supplier</strong>
              <p className="text">
                Independent contractor or third party providing specific
                services such as hotels, airlines, cruise lines, transport
                providers, tour operators or activity providers.
              </p>{" "}
            </p>

            <p className="text">
              <strong>Lead Passenger</strong>
              <p className="text">
                The individual making the booking on behalf of all passengers
                included in the reservation.
              </p>{" "}
            </p>
            <p className="text"> </p>
          </div>
          <div className="policy-block">
            <h4>3. Booking &Confirmation</h4>
            <p className="text">
              <p className="text"> A booking is confirmed only when:</p>

              <ul>
                <li className="list-item">
                  The Company issues a <strong>written confirmation,</strong>{" "}
                  and
                </li>

                <li className="list-item">
                  The required <strong>deposit or full payment</strong> is
                  received.
                </li>
              </ul>
            </p>
            <p className="text">
              All bookings are subject to availability at the time of
              reservation. Bookings made close to the travel date (e.g., within
              7 days of travel) may require{" "}
              <strong>immediate full payment.</strong> The Lead Passenger
              confirms that they have the authority to accept these Terms &
              Conditions on behalf of all travellers in the booking.
            </p>
          </div>
          <div className="policy-block">
            <h4>4. Payment Terms</h4>
            <p className="text">
              <p className="text">
                Clients must pay the required deposit and/or full payment as
                indicated at the time of booking. Failure to make payment by the
                specified deadline may result in automatic cancellation of the
                booking.
              </p>
              <p className="text"> All payments shall be made in:</p>
              <p className="text">
                <strong>
                  United States Dollar (USD) or Indian Rupees (INR)
                </strong>{" "}
                unless otherwise agreed.
              </p>
              <p className="text"> Accepted payment methods may include:</p>
              <ul>
                <li className="list-item">Bank transfer</li>
                <li className="list-item">Credit / Debit card</li>
                <li className="list-item">Online payment gateways</li>
                <li className="list-item">
                  Any other payment method accepted by the Company.
                </li>
              </ul>
            </p>
          </div>
          <div className="policy-block">
            <h4>5. Pricing & Currency Fluctuation</h4>

            <p className="text">
              {" "}
              Tour prices are based on current:
              <ul>
                <li className="list-item">Exchange rates</li>
                <li className="list-item">Supplier tariffs</li>
                <li className="list-item">Government taxes</li>
                <li className="list-item">Fuel costs</li>
                <li className="list-item">Service charges</li>
              </ul>
            </p>

            <p className="text">
              The Company reserves the right to revise prices before booking
              confirmation if there are changes in:
              <ul>
                <li className="list-item">supplier rates</li>
                <li className="list-item">currency exchange fluctuations</li>
                <li className="list-item">government taxes</li>
                <li className="list-item">fuel surcharges.</li>
              </ul>{" "}
            </p>
          </div>
          <div className="policy-block">
            <h4>6. Cancellation, Non-Refundable Policy& Refunds</h4>

            <p className="text">
              All cancellations must be communicated <strong></strong>
            </p>
            <p className="head">
              <strong>Non-Refundable Booking Policy</strong>
            </p>
            <p className="text">
              Once a booking is confirmed, the Company immediately secures
              reservations with airlines, hotels, cruise operators, transport
              providers and other travel suppliers.
            </p>

            <p className="text">
              These reservations often involve{" "}
              <strong>non-refundable commitments.</strong>
            </p>

            <p className="text">
              <strong>
                {" "}
                All bookings are treated as confirmed contractual reservations
                and may be partially or fully non-refundable once confirmed.
              </strong>
              Therefore:<br></br>
              If the client cancels the booking after confirmation,
              <strong>
                cancellation charges will apply as per the cancellation policy
                or supplier terms (whichever is higher).
              </strong>
            </p>

            <h3 className="head">
              {" "}
              Standard Cancellation Charges (Land Packages)
            </h3>
            <p className="text">
              <ul>
                <li className="list-item">
                  <strong>30 days or more before departure:</strong> 25% of
                  total package cost
                </li>
                <li className="list-item">
                  <strong>15 – 29 days before departure:</strong> 50% of total
                  package cost
                </li>
                <li className="list-item">
                  <strong>07 – 14 days before departure:</strong> 75% of total
                  package cost
                </li>
                <li className="list-item">
                  <strong>No Show / Failure to Travel:</strong> 100% of total
                  package cost
                </li>
              </ul>
            </p>
            <p className="text">
              Supplier policies may override the above cancellation charges
              where applicable.
            </p>

            <h3 className="head">
              Flights, Cruises, Visa & Promotional Bookings
            </h3>
            <p className="text">
              Airline tickets, cruise bookings, visa services and special
              promotional fares may be{" "}
              <strong>100% non- refundable once confirmed or issued.</strong>
              Cancellation terms of the respective{" "}
              <strong>
                airline, cruise company, embassy or supplier will apply.
              </strong>
            </p>

            <h3 className="head">Refund Processing</h3>
            <p className="text">
              If a refund is applicable after supplier deductions and
              administrative charges, it will be processed within{" "}
              <strong>15 – 30 working days</strong> after funds are received
              from the respective supplier.
              <strong>
                airline, cruise company, embassy or supplier will apply.
              </strong>
              No refunds will be provided for:
              <p className="text">
                <ul>
                  <li className="list-item">unused services</li>
                  <li className="list-item">missed flights</li>
                  <li className="list-item">early departures</li>
                  <li className="list-item">no-shows.</li>
                </ul>
              </p>
            </p>
          </div>
          <div className="policy-block">
            <h4>7. Changes by Client</h4>

            <p className="text">
              If a client requests changes to a confirmed booking, the Company
              will attempt to accommodate the request subject to supplier
              approval and availability.
            </p>
            <p className="text">Additional costs may include:</p>
            <p className="text">
              <ul>
                <li className="list-item">supplier amendment fees</li>
                <li className="list-item">fare differences</li>
                <li className="list-item">administrative handling charges.</li>
              </ul>
            </p>
          </div>
          <div className="policy-block">
            <h4>8. Changes by Supplier or Company</h4>

            <p className="text">
              Travel itineraries may occasionally require modification due to:
            </p>
            <p className="text">
              <ul>
                <li className="list-item">supplier operational adjustments</li>
                <li className="list-item">weather conditions</li>
                <li className="list-item">safety concerns.</li>
                <li className="list-item">transportation schedules</li>
                <li className="list-item">events beyond our control..</li>
              </ul>
            </p>
            <p className="text">
              Where possible, the Company will offer alternative arrangements of
              similar value. Refunds may be provided only for services not
              supplied, subject to supplier terms.
            </p>
          </div>
          <div className="policy-block">
            <h4>9. Travel Documents</h4>

            <p className="text">
              Clients are responsible for obtaining valid travel documents
              including:
            </p>
            <p className="text">
              <ul>
                <li className="list-item">passports</li>
                <li className="list-item"> visas</li>
                <li className="list-item"> permits</li>
                <li className="list-item"> health certificates</li>
                <li className="list-item">vaccination requirements</li>
              </ul>
            </p>

            <p className="text">
              The Company is not liable for denied entry or travel disruptions
              due to incorrect or incomplete documentation.
            </p>
          </div>
          <div className="policy-block">
            <h4>10. Travel Insurance</h4>

            <p className="text">
              Travel insurance covering medical emergencies, trip cancellation,
              baggage loss and travel disruption is{" "}
              <strong>strongly recommended.</strong>
              <p className="text">
                Clients acknowledge that obtaining travel insurance is their
                responsibility unless otherwise agreed in writing.
              </p>
            </p>
            <p className="text">
              The Company is not liable for denied entry or travel disruptions
              due to incorrect or incomplete documentation.
            </p>
          </div>
          <div className="policy-block">
            <h4>11. Supplier Terms</h4>

            <p className="text">
              Many travel suppliers impose their own conditions including:
              <ul>
                <li className="list-item">cancellation rules</li>
                <li className="list-item"> baggage allowances</li>
                <li className="list-item"> check-in requirements</li>
                <li className="list-item"> refund policies.</li>
              </ul>
              <p className="text">
                Clients agree to comply with the terms imposed by each supplier.
                The Company is{" "}
                <strong>
                  not liable for acts, errors, delays, cancellations, defaults
                  or bankruptcy of suppliers.
                </strong>
              </p>
            </p>
          </div>
          <div className="policy-block">
            <h4>12. Limitation of Liability</h4>

            <p className="text">
              Adesh Tours and Travels acts solely as a travel facilitator and
              booking agent for independent suppliers.
              <p className="text">
                The Company does not own, control or operate airlines, hotels,
                cruise ships, transport companies or other travel providers.
              </p>
              Therefore, the Company shall not be liable for:
            </p>

            <p className="text">
              <ul>
                <li className="list-item">lost baggage</li>
                <li className="list-item"> visa rejections</li>
                <li className="list-item"> natural disasters</li>
                <li className="list-item"> government restrictions</li>
                <li className="list-item">political unrest or strikes.</li>
              </ul>
            </p>
            <p className="text">
              The Company's liability, if any, is limited strictly to the
              service fees paid directly to Adesh Tours and Travels.
            </p>
          </div>
          <div className="policy-block">
            <h4>13. Behaviour</h4>

            <p className="text">
              All travellers must behave responsibly and comply with:
            </p>
            <p className="text">
              <ul>
                <li className="list-item"> local laws</li>
                <li className="list-item"> cultural customs</li>
                <li className="list-item"> accommodation rules</li>
                <li className="list-item"> safety guidelines.</li>
              </ul>
            </p>
            <p className="text">
              The Company reserves the right to remove any traveller whose
              behaviour is disruptive, unsafe or unlawful.
            </p>
            <p className="text">
              No refunds will be provided in such circumstances.
            </p>
          </div>
          <div className="policy-block">
            <h4>14. Complaints</h4>
            <p className="text">
              Any complaint regarding services must be reported immediately
              during the trip so that efforts can be made to resolve the issue.
            </p>{" "}
            <p className="text">
              Formal complaints must be submitted in writing within{" "}
              <strong>7 days after completion of travel.</strong>
            </p>
          </div>
          <div className="policy-block">
            <h4>15. Data Protection</h4>
            <p className="text">
              By making a booking, clients consent to the collection, storage
              and use of their personal data for the purpose of processing
              travel services in accordance with applicable privacy laws.
            </p>{" "}
          </div>
          <div className="policy-block">
            <h4>16. Intellectual Property</h4>
            <p className="text">
              All content, trademarks, branding, logos and materials provided by
              the Company remain the intellectual property of Adesh Tours and
              Travels and may not be used without written permission.
            </p>{" "}
          </div>
          <div className="policy-block">
            <h4>17. Force Majeure</h4>
            <p className="text">
              The Company shall not be liable for failure to perform obligations
              due to events beyond its reasonable control including but not
              limited to:
            </p>{" "}
            <p className="text">
              <ul>
                <li className="list-item"> natural disasters</li>
                <li className="list-item">war or civil unrest</li>
                <li className="list-item"> pandemics</li>
                <li className="list-item"> strikes</li>
                <li className="list-item"> government restrictions</li>
                <li className="list-item"> airline operational disruptions.</li>
              </ul>
            </p>
            <p className="text">
              In such cases, refunds or changes will depend solely on{" "}
              <strong>supplier policies.</strong>
            </p>{" "}
          </div>
          <div className="policy-block">
            <h4>18. Payment Disputes & Chargebacks</h4>
            <p className="text">
              By making a payment to Adesh Tours and Travels, the client
              confirms acceptance of these Terms & Conditions.
            </p>{" "}
            <p className="text">
              {" "}
              Clients agree{" "}
              <strong>
                not to initiate payment chargebacks or disputes
              </strong>{" "}
              for services that have been confirmed in accordance with these
              Terms.
            </p>
            <p className="text">
              {" "}
              If a chargeback or payment dispute is initiated:
            </p>
            <p className="text">
              <ul>
                <li className="list-item">
                  {" "}
                  the client remains liable for the full booking amount
                </li>
                <li className="list-item">
                  any bank fees, administrative charges and legal costs will be
                  recoverable from the client
                </li>
                <li className="list-item">
                  {" "}
                  the Company reserves the right to pursue{" "}
                  <strong>legal action for recovery of dues.</strong>
                </li>
              </ul>
            </p>
          </div>
          <div className="policy-block">
            <h4>19. Applicable Law & Jurisdiction</h4>
            <p className="text">
              These Terms & Conditions are governed by the laws of India.
            </p>{" "}
            <p className="text">
              {" "}
              Any disputes arising from bookings with Adesh Tours and Travels
              shall be subject to the{" "}
              <strong>
                exclusive jurisdiction of the courts of Ahmedabad, Gujarat,
                India.
              </strong>
            </p>
          </div>
          <div className="policy-block">
            <h4>Client Acknowledgement</h4>
            <p className="text">
              By making a booking with <strong>Adesh Tours and Travels,</strong>{" "}
              the client confirms that they have{" "}
              <strong>
                read, understood and agreed to all Terms & Conditions stated
                above
              </strong>
            </p>{" "}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Terms_Conditions;
